import { SxProps, Theme } from "@mui/material";

export const SHELL_PADDING = 0;
export const SIDEBAR_WIDTH = 272;

export const APP_BAR_HEIGHT = { xs: 60, md: 72 } as const;

export const ACTION_ICON_SIZE = 22;
export const ACTION_BUTTON_SIZE = 40;

export const actionIconButtonSx: SxProps<Theme> = {
  width: ACTION_BUTTON_SIZE,
  height: ACTION_BUTTON_SIZE,
  borderRadius: 2,
  transition: "background-color 0.2s ease, transform 0.15s ease",
  "&:hover": {
    transform: "scale(1.04)",
  },
};

export const shellPaperSx: SxProps<Theme> = {
  display: "flex",
  flex: 1,
  minHeight: "100vh",
  bgcolor: "background.paper",
  overflow: "hidden",
};

export const formPageSurfaceSx: SxProps<Theme> = {
  width: "100%",
  bgcolor: "background.paper",
  borderRadius: 2,
  border: 1,
  borderColor: "divider",
  p: { xs: 2.5, sm: 3, md: 3.5 },
  boxShadow: "0 1px 2px rgba(26, 26, 46, 0.04), 0 4px 16px rgba(26, 26, 46, 0.04)",
};
